"use strict";

module.exports = function (value) {
	try {
		return value.toString();
	} catch (error) {
		try { return String(value); }
		catch (error2) { return null; }
	}
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/type/lib/safe-to-string.js
// module id = ../../../node_modules/type/lib/safe-to-string.js
// module chunks = 1